import {useQuery} from 'react-query';

import getOptionalAttributes from '.';

const useGetOptionalAttributes = (type?: string) => {
  const {data, isLoading} = useQuery(
    ['get-optional-attribute', type],
    getOptionalAttributes,
  );

  return {attributesData: data, isLoading};
};

export default useGetOptionalAttributes;
